import { formatDensityRange } from "@design-system/DensityChart/DensityChart.lib";
import { formatDateOnly } from "@helpers/date";

/**
 * History's start day for the zone's sentence: "Oct 19", with the year when
 * it isn't `today`'s year. The sentence wraps around the date, never inside
 * it.
 */
export function formatHistoryStart({
    start,
    today,
}: {
    start: string;
    today: string;
}): string {
    const isThisYear = start.slice(0, 4) === today.slice(0, 4);
    const label = isThisYear
        ? formatDensityRange({ start, end: start })
        : formatDateOnly(start, "MMM d, yyyy");
    return label.replaceAll(" ", "\u00a0");
}
